import { useEffect, useState } from 'react';

export interface TimerProps {
  activated: boolean;
}

export interface Timer {
  timer: number;
}
const useTimer = ({ activated }: TimerProps): Timer => {
  const [timer, setTimer] = useState<number>(0);

  useEffect(() => {
    if (!activated) {
      return;
    }
    const timer = setInterval(() => {
      setTimer((_time) => _time + 1);
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, [activated]);
  return { timer };
};

export default useTimer;
